<template>
  <div>
    <div
      class="mx-auto max-w-screen-xl grid grid-cols-5 md:gap-x-10 lg:gap-x-16"
    >
      <h2 class="block-heading font-medium text-los-blue-darkest col-span-full">
        Al onze workshops en trainingen
      </h2>
      <div class="col-span-full md:col-span-3">
        <p class="text-lg/8 md:text-xl/9">
          Bij Los Naaimachines doen we iedere dag wat we het liefst doen: onze
          passie met creatievelingen delen. Met onze workshops en trainingen ga
          je in de praktijk aan de slag en leer je de leukste dingen van onze
          ervaren docenten. Daarnaast ontmoet je andere creatievelingen die, net
          als jij, het liefst creatief bezig zijn. Hoe leuk is dat!
        </p>
        <p class="text-lg/8 md:text-xl/9 mt-5">
          Heb je interesse in een training of workshop, maar staat deze niet op
          de planning? Laat het ons weten, dan kijken we graag met je mee naar
          de mogelijkheden.
        </p>
      </div>
      <div
        class="sm:col-start-2 md:col-start-auto col-span-full min-[420px]:col-span-4 sm:col-span-3 md:col-span-2 mt-6 md:mt-0"
      >
        <div
          class="bg-los-yellow-lightest px-10 md:px-6 py-6 rounded-lg relative shadow"
        >
          <h3 class="text-lg lg:text-xl font-semibold mb-3">
            Onze workshops en trainingen:
          </h3>
          <ul>
            <li
              class="list-item list-disc ml-5 marker:font-semibold marker:text-los-purple-dark mb-2 lg:text-lg"
              v-for="type in allWorkshopTypes"
              :key="type.id"
            >
              <NuxtLink
                class="hover:underline"
                :to="`/workshops/${type.slug}`"
                >{{ type.name }}</NuxtLink
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { find } = useStrapi();

const { data: allWorkshopTypesData } = await useAsyncData(
  'all-workshop-types',
  () =>
    find('workshop-types', {
      filters: { hidden: { $ne: true } },
      fields: ['name', 'slug'],
      sort: ['name'],
    })
);

const allWorkshopTypes = computed(() => {
  return allWorkshopTypesData.value?.data;
});
</script>

<style lang="scss" scoped></style>
